import React from 'react';
import Checkbox from '../../../../../../component/checkbox/Checkbox';
import * as css from './EventsTableRow.css';
import {useTranslation} from 'react-i18next';
import SuccessIcon from '../../../../../../assets/icons/SuccessIcon';
import EventKindDropdown from '../eventKindDropdown/EventKindDropdown';
import {EventsTableRowProps} from '../../utils/types';
import {getStatusText, getCategoryText, isEventOutsideSaleValidity} from '../../utils/utils';
import useMobile from '../../../../../../hooks/useMobile';
import {defaultImage} from '../../../../../../assets/symbols/images/defaultImage';

export default function EventsTableRow({event, handleEvent, showEventKind = false, onOpenDetailsPopup, saleStart, saleEnd}: EventsTableRowProps) {
    const {t} = useTranslation('subscriptions');
    const {t: tLayout} = useTranslation('layout');
    const isMobile = useMobile();

    const handleCheckboxChange = (checked: boolean) => {
        handleEvent('change', {id: event.id, name: 'selected', value: checked});
    };

    const handleRowClick = (e: React.MouseEvent) => {
        const isDisabled = event.status === 'expired'
            || isEventOutsideSaleValidity(event.event, saleStart, saleEnd);
        // Prevent action if event is disabled and not selected (allow un-selecting)
        if(isDisabled && !event.selected) {
            return;
        }
        // Only open popup on mobile devices
        if(!isMobile || !onOpenDetailsPopup) {
            return;
        }
        // Prevent opening popup when clicking on checkbox or dropdown
        const target = e.target as HTMLElement;
        if(target.closest('[data-prevent-popup]')) {
            return;
        }
        onOpenDetailsPopup(event);
    };

    const isDisabled = event.status === 'expired'
        || isEventOutsideSaleValidity(event.event, saleStart, saleEnd);

    return (
        <>
            <css.eventItem selected={event.selected} disabled={isDisabled} onClick={handleRowClick}>
                <css.image image={event.event?.fbImg || defaultImage} />
                <css.select data-prevent-popup data-cy={`assign-events-event-${event.id}-checkbox`}>
                    <Checkbox
                        selected={event.selected}
                        onClick={handleCheckboxChange}
                        classes={'classicCheckbox'}
                        color="primary"
                        disabled={isDisabled && !event.selected}
                    />
                    <css.successIcon>{event.selected && <SuccessIcon />}</css.successIcon>
                </css.select>
                <css.title to={`/e/${event.id}/realtime`} target="_blank" onClick={(e) => e.stopPropagation()}>{event.title}</css.title>
                {!isMobile&&<><css.date>{event.date}</css.date>
                    <css.time>{event.time}</css.time>
                    <css.category>{getCategoryText(event.category, tLayout)}</css.category>
                    <css.locationText>{event?.location || '-'}</css.locationText></>}
                <css.statusBadge status={event.status}>
                    {getStatusText(event.status, t)}
                </css.statusBadge>
                {showEventKind && (
                    <EventKindDropdown
                        eventId={event.id}
                        eventKind={event.eventKind}
                        isSelected={event.selected}
                        handleEvent={handleEvent}
                        disabled={isDisabled}
                    />
                )}
            </css.eventItem>
        </>
    );
}
